import { featureTogglingConfig } from '@app/shared/constants/feature.config';
import { Settings, EnvironmentType } from './../app/core/settings';

/**
 * Base URL settings (development)
 *
 *
 */
// const settings: Settings = {

//   //identityServiceUrl: 'https://deliveropedia.com/',

//   // identityServiceUrl: 'http://37.34.189.202:8050/Development/Posthub.IdentityService',
//   // backendUrl: 'http://37.34.189.202:8050/Development/Posthub.DeliveryService',
//   // orderServiceUrl: 'http://37.34.189.202:8050/Development/Posthub.OrderService',

//     identityServiceUrl: 'http://52.224.240.66:8088/PostHubConcierge/Posthub.IdentityService',
//     backendUrl: 'http://52.224.240.66:8088/PostHubConcierge/Posthub.DeliveryService',
//     orderServiceUrl: 'http://52.224.240.66:8088/PostHubConcierge/Posthub.OrderService',


//   // identityServiceUrl: 'http://37.34.189.202:8050/test/Posthub.IdentityService',
//   // backendUrl: 'http://37.34.189.202:8050/test/Posthub.DeliveryService',
//   // orderServiceUrl: 'http://37.34.189.202:8050/test/Posthub.OrderService',

//   // backendUrl: 'http://localhost:5000',
//   // identityServiceUrl: 'https://localhost:44365',
//   // orderServiceUrl: 'https://localhost:44395',

//   // identityServiceUrl: 'http://3.10.142.186/Release/posthub.identityservice',
//   // backendUrl: 'http://3.10.142.186/Release/posthub.deliveryservice',
//   // orderServiceUrl: 'http://3.10.142.186/Release/posthub.orderservice',
//   environmentType: EnvironmentType.Development
// };

let settings: Settings;
if (featureTogglingConfig.environment.concierge) {
    settings = {
        // identityServiceUrl: 'http://52.224.240.66:8088/PostHubConcierge/Posthub.IdentityService',
        // backendUrl: 'http://52.224.240.66:8088/PostHubConcierge/Posthub.DeliveryService',
        // orderServiceUrl: 'http://52.224.240.66:8088/PostHubConcierge/Posthub.OrderService',

        //backendUrl: 'http://localhost:5000',
        //identityServiceUrl: 'https://localhost:44335',
        //orderServiceUrl: 'https://localhost:44395',

        //  identityServiceUrl: 'https://identity.mrconcierge.world',
        //  backendUrl: 'https://mrconcierge.world/posthub.deliveryservice',
        //  orderServiceUrl: 'https://mrconcierge.world/posthub.orderservice',
//http://posthub-dev.dhub.pro/
        identityServiceUrl: 'https://posthub-dev.dhub.pro/Posthub.IdentityService',
        backendUrl: 'https://posthub-dev.dhub.pro/Posthub.DeliveryService',
        orderServiceUrl: 'https://posthub-dev.dhub.pro/Posthub.OrderService',

        // identityServiceUrl: 'http://13.41.239.125/Release/posthub.identityservice',
        // backendUrl: 'http://13.41.239.125/Release/posthub.deliveryservice',
        // orderServiceUrl: 'http://13.41.239.125/Release/posthub.orderservice',


        environmentType: EnvironmentType.Development

    }
}
else if (featureTogglingConfig.environment.express) {
    settings = {

        //identityServiceUrl: 'http://3.10.142.186/Release/posthub.identityservice',
        //backendUrl: 'http://3.10.142.186/Release/posthub.deliveryservice',
        //orderServiceUrl: 'http://3.10.142.186/Release/posthub.orderservice',

        // identityServiceUrl: 'https://test.deliveropedia.com',
        // backendUrl: 'http://3.10.142.186/test/posthub.deliveryservice',
        // orderServiceUrl: 'http://3.10.142.186/test/posthub.orderservice',
        //backendUrl: 'http://localhost:5000',
        //identityServiceUrl: 'http://localhost:44365',
        //orderServiceUrl: 'http://localhost:44395',

        //Local
        // backendUrl: 'http://localhost:5000',
        // identityServiceUrl: 'https://localhost:44335',
        // orderServiceUrl: 'https://localhost:44395',

        identityServiceUrl: 'https://posthub.dhub.pro/Posthub.IdentityService',
        backendUrl: 'https://posthub.dhub.pro/Posthub.DeliveryService',
        orderServiceUrl: 'https://posthub.dhub.pro/Posthub.OrderService',


        // identityServiceUrl: 'http://13.41.239.125/Release/posthub.identityservice',
        // backendUrl: 'http://13.41.239.125/Release/posthub.deliveryservice',
        // orderServiceUrl: 'http://13.41.239.125/Release/posthub.orderservice',


        environmentType: EnvironmentType.Development

    }
}

export const environment = {
    production: false,
    settings: settings,
};